<script>
    import { checkActionCode, applyActionCode, sendPasswordResetEmail } from "firebase/auth";

    export let auth;
    export let actionCode;
    // export let continueUrl;
    // export let lang;

    let restoredEmail = null;
    let emailReverted;

    // Confirm the action code is valid.
    checkActionCode(auth, actionCode)
    .then((res) => {
        restoredEmail = res.data.email;
        // restoredEmail = info['data']['email'];

        // Revert to the old email.
        return applyActionCode(auth, actionCode)
        .then(() => {
            emailReverted = true;
        })
        .catch((error) => {
            // Invalid code.
            console.log(error);
        });
    }).catch((error) => {
        // Invalid code.
        console.log(error);
    });
</script>

<div class="form">
    {#if emailReverted}
        <h1>Aktualisierte E-Mail-Adresse</h1>
        <p>Deine Anmelde-E-Mail-Adresse wurde wieder in <b>{restoredEmail}</b> geändert.</p>
        <p>Wenn Du nicht um die Änderung der Anmelde-E-Mail-Adresse gebeten hast, versucht möglicherweise jemand anderes, auf dein Konto zuzugreifen. In diesem Fall solltest du <a href="/passwort/reset">dein Passwort sofort ändern.</a></p>
    {/if}
</div>

<style>
    .form {
        max-width: 30rem;
        margin: auto;
    }
</style>